import { put, call, select } from 'redux-saga/effects';
import * as types from '../../constants/ActionTypes';
import Api from '../../functions/Api';

export function* addRequisites({ data }) {
  try {
    const { data: payload } = yield call(Api.post, 'v2/requisite/', {
      data,
    });
    yield put({
      type: types.ADD_REQUISITES_SUCCESS,
      payload,
    });
  } catch (error) {
    yield put({
      type: types.ADD_REQUISITES_FAILURE,
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* updateRequisites({ data }) {
  try {
    const requisiteId = yield select((state) => state.user.requisites.id);
    const { data: payload } = yield call(
      Api.put,
      `v2/requisite/${requisiteId}/`,
      {
        data,
      }
    );
    yield put({
      type: types.UPDATE_REQUISITES_SUCCESS,
      payload,
    });
  } catch (error) {
    yield put({
      type: types.UPDATE_REQUISITES_FAILURE,
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}
